import { Grid } from '@mui/material'
import React from 'react'
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import StatusGrid from './TableComponent';

const StatusTable = () => {
    const [value, setValue] = React.useState('one');

    const handleChange = (event, newValue) => {
      setValue(newValue);
    };
    return (
        <Grid container>
            <Grid item xl={12}  sm={12} xs={12}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    textColor="secondary"
                    indicatorColor="secondary"
                    aria-label="secondary tabs example"
                >
                    <Tab value="one" label="All" />
                    <Tab value="two" label="Pending" />
                    <Tab value="three" label="Approved" />
                    <Tab value="four" label="Rejected" />
                </Tabs>
            </Grid>

            <Grid item xl={12} sm={12} xs={12} mt={1}>
                <StatusGrid/>
            </Grid>

        </Grid>
    )
}

export default StatusTable
